import { createFileRoute } from "@tanstack/react-router";

import { HotelskiMenadzmentPage } from "../about_.hotelski-menadzment";

export const Route = createFileRoute("/en/about_/hotelski-menadzment")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "Hotel Management | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Meet the hotel management team of Makedonijaturist AD. Professionalism and experience in managing our hotel properties.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about/hotelski-menadzment",
			},
		],
	}),
	component: HotelskiMenadzmentPage,
});
